"use client";

import { motion } from "framer-motion";
import { HandCoins, PiggyBank } from "lucide-react";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export type FundingOption = { name: string; text: string };

export default function ScholarshipSection({
  options,
  note,
}: {
  options: FundingOption[];
  /** Optionale hochschulspezifische Finanzierungsnotiz. */
  note?: string;
}) {
  return (
    <motion.section
      variants={stagger(0.09)}
      initial="hidden"
      whileInView="visible"
      viewport={viewportOnce}
      aria-labelledby="scholarship-heading"
    >
      <motion.p
        variants={fadeUp}
        className="flex items-center gap-2.5 text-xs font-bold uppercase tracking-widest text-accent mb-3"
      >
        <HandCoins size={14} aria-hidden="true" />
        Finanzierung
      </motion.p>
      <motion.h2
        variants={fadeUp}
        id="scholarship-heading"
        className="font-display font-bold text-2xl sm:text-3xl tracking-tight text-ink mb-6"
      >
        Stipendien &amp; Finanzierung
      </motion.h2>

      {note && (
        <motion.p
          variants={fadeUp}
          className="flex gap-3 rounded-xl border border-accent/20 bg-accent-soft/60 px-4 py-3.5 text-sm text-ink leading-relaxed mb-6"
        >
          <PiggyBank size={17} className="text-accent shrink-0 mt-px" aria-hidden="true" />
          <span>{note}</span>
        </motion.p>
      )}

      <div className="grid sm:grid-cols-2 gap-4">
        {options.map((option) => (
          <motion.div
            key={option.name}
            variants={fadeUp}
            className="card-flat flex flex-col gap-1.5 bg-white/60 p-5"
          >
            <h3 className="font-display font-semibold text-base text-ink">{option.name}</h3>
            <p className="text-sm text-ink-soft leading-relaxed">{option.text}</p>
          </motion.div>
        ))}
      </div>
    </motion.section>
  );
}
